<template>
  <v-row justify="center">
    <v-col cols="6">
      <DistributionSettingsComponent v-model="steps" :strategyOptions="strategyOptions">

        <template v-slot:surroundingArea="{step}">
          <SurroundingAreaStrategyComponent :step="step"/>
        </template>

      </DistributionSettingsComponent>
      <pre>
      <h2>Steps</h2>
        <code>{{ JSON.stringify(steps, null, "\t") }}</code>
      </pre>
    </v-col>
  </v-row>
</template>

<script>
import DistributionSettingsComponent from "@/components/lead/marketplace/distribution/DistributionSettingsComponent";
import {reactive} from "@vue/composition-api";
import SurroundingAreaStrategyComponent
  from "@/components/lead/marketplace/distribution/strategies/SurroundingAreaStrategyComponent";

export default {
  name: "MarketplaceAdministrationView",
  components: {SurroundingAreaStrategyComponent, DistributionSettingsComponent},
  setup() {

    const strategyOptions = [
      {text: 'Umkreis', value: 'surroundingArea'},
      {text: 'Alle', value: 'all'}
    ]

    const steps = reactive([
      {
        strategy: 'surroundingArea',
        time: '01:12:45',
        settings: {radius: 45}
      },
      {
        strategy: 'surroundingArea',
        time: '01:12:45'
      },
      {
        strategy: 'surroundingArea',
        time: '01:12:45'
      },
      {
        strategy: 'all',
        time: '01:12:45'
      },
      {
        strategy: 'all',
        time: '01:12:45'
      }
    ])
    return {steps, strategyOptions}
  }
}
</script>

<style scoped>

</style>
